import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import axios from "axios";
import { clearAuthToken, getAuthToken } from "@/utils/token";
const baseURL = process.env.REACT_APP_API_BASE_URL || "https://api.yueman.vip";
axios.defaults.baseURL = baseURL;
axios.defaults.withCredentials = true;
const instance = axios.create({
  baseURL,
  timeout: 15000,
  withCredentials: true
});
instance.interceptors.request.use(config => {
  const token = getAuthToken();

  if (token) {
    config.headers = { ...(config.headers || {}),
      Authorization: "Bearer " + token
    };
  }

  return config;
}, error => Promise.reject(error));
let redirectingToLogin = false;

const redirectToLogin = message => {
  if (typeof window === "undefined" || redirectingToLogin) {
    return;
  }

  redirectingToLogin = true;
  clearAuthToken();
  window.localStorage.setItem("userStatus", "logout");

  _Message.error(message || "登录信息已过期，请重新登录");

  const isLoginPage = window.location.pathname === "/login";

  if (!isLoginPage) {
    window.location.replace("/login");
  } else {
    redirectingToLogin = false;
  }
};

instance.interceptors.response.use(response => {
  const {
    data
  } = response;

  if (data && typeof data === "object" && data.code === 401) {
    redirectToLogin(data.message);
  }

  return response;
}, error => {
  if (error.response?.status === 401) {
    redirectToLogin(error.response?.data?.msg || error.response?.data?.message || error.message);
    return Promise.reject(error);
  }

  const message = error.response?.data?.msg || error.response?.data?.message || error.message || "请求失败";

  _Message.error(message);

  return Promise.reject(error);
});

const request = config => instance.request(config).then(res => res.data);

request.get = (url, config) => request({ ...(config || {}),
  method: "get",
  url
});

request.post = (url, data, config) => request({ ...(config || {}),
  method: "post",
  url,
  data
});

request.put = (url, data, config) => request({ ...(config || {}),
  method: "put",
  url,
  data
});

request.delete = (url, config) => request({ ...(config || {}),
  method: "delete",
  url
});

request.instance = instance;
export default request;